import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import {
	AlarisIconDirective,
	AlarisTagComponent,
	AlarisTooltipDirective,
	ChannelUtilsService,
} from '@campaign-portal/components-library';
import { TranslateModule } from '@ngx-translate/core';
import { NgTemplateOutlet } from '@angular/common';
import {
	Campaign,
	CampaignChannelStatistics,
	CampaignStatus,
} from '@campaign-portal/namespace/entities/campaigns/specs';
import { ChannelType } from '@campaign-portal/namespace/common/enums';
import { exist } from '@campaign-portal/namespace/common/id';
import { CampaignUtilsService } from '@shared/services/campaign-utils.service';

@Component({
	selector: 'app-campaign-cascade-table',
	imports: [AlarisIconDirective, AlarisTagComponent, TranslateModule, NgTemplateOutlet, AlarisTooltipDirective],
	templateUrl: './campaign-cascade-table.component.html',
	styleUrl: './campaign-cascade-table.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignCascadeTableComponent implements OnChanges {
	@Input({ required: true }) campaign!: Campaign<exist>;

	channelsStatistics: CampaignChannelStatistics[] = [];

	readonly CampaignStatus = CampaignStatus;
	readonly ChannelType = ChannelType;

	constructor(
		public cu: ChannelUtilsService,
		public campaignUtils: CampaignUtilsService
	) {}

	ngOnChanges(): void {
		this.setStatistics();
	}

	private setStatistics(): void {
		const emptyStats: CampaignChannelStatistics = {
			total: 0,
			messageCount: 0,
			contactCount: 0,
			failed: 0,
			seen: 0,
			sent: 0,
			delivered: 0,
			undelivered: 0,
			channelType: ChannelType.SMS,
		};

		this.channelsStatistics = [];

		for (const { channelType } of this.campaign.setup.channels) {
			let found: CampaignChannelStatistics | undefined;

			for (const channelStats of this.campaign.statistics?.campaignChannelStatistics ?? []) {
				if (channelStats.channelType === channelType) {
					found = channelStats;
					break;
				}
			}

			this.channelsStatistics.push(found ?? { ...emptyStats, channelType });
		}
	}
}
